import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = [{
    title: 'Guía Digital Protocolo 11:11',
    desc: 'El paso a paso para activar tu blindaje en 180 segundos.'
  }, {
    title: 'Técnica del Dial de Frecuencia',
    desc: 'Cómo hacerte invisible al radar de personas tóxicas sin cerrar los ojos.'
  }, {
    title: 'El Anclaje de Tierra 3-2-1',
    desc: "Un sistema de descarga rápida para cuando ya te sientes 'contaminado'."
  }, {
    title: 'Manual de Detección de Vampiros',
    desc: 'Identifica los 3 perfiles que roban tu energía antes de que se acerquen.'
  }, {
    title: 'Checklist de Blindaje del Hogar',
    desc: 'Convierte tu habitación en un santuario donde nada externo pueda entrar.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-197">
      <div className="max-w-6xl mx-auto" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-199">
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-200">
            Lo Que Recibes Hoy
          </h2>
          <div className="w-16 h-1 bg-gold-500 mx-auto" data-id="element-201" />
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-202">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1" data-id="element-203">
            <div className="space-y-6" data-id="element-204">
              {deliverables.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex gap-4 p-4 rounded-lg hover:bg-navy-800/50 transition-colors" data-id="element-205">
                  <CheckCircle2 className="w-6 h-6 text-gold-400 flex-shrink-0 mt-1" data-id="element-206" />
                  <div data-id="element-207">
                    <h3 className="text-white font-medium text-lg mb-1" data-id="element-208">
                      {item.title}
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-209">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-1 lg:order-2 relative" data-id="element-210">
            <div className="absolute inset-0 bg-radial-gold opacity-50 blur-2xl" data-id="element-211" />
            <img src="https://cdn.magicpatterns.com/uploads/9UdNJotgKStSfvrpibjTaT/Mockup.png" alt="Contenido del Protocolo 11:11" className="relative z-10 w-full h-auto rounded-xl shadow-2xl border border-navy-700/50" data-id="element-212" />
          </motion.div>
        </div>
      </div>
    </section>;
}